import axios from "axios";


const instance = axios.create({
  baseURL: `${window.location.origin}`,
  withCredentials: false,
});

const urlSso = "/api/user/loginSso";

export const useLoginSso = async () => {
  instance
    .get(urlSso)
    .then(response => {
      console.log("response data from sso is : ",response.data);
      window.location.href = response.data;
    })
    .catch(error => {
      console.error("useLoginSso", error.message);
    });
  
};
